<template>
    <div class="row comments-list-item align-middle comments-list-item" :class="{ unseen: !seen }">
        <div class="small-12 medium-6 column" style="position: relative;">
            <router-link v-if="comment.author" :to="{ name: 'profiles', params: { id: comment.author.id } }" class="avatar-link">
                <avatar :avatar="comment.author.avatar" class="icon-inline icon-avatar"></avatar>
            </router-link>
            <div class="comment-details">
                <router-link :to="{ name: 'profiles', params: { id: comment.author.id } }" class="author-link">{{ comment.author.name }}</router-link>
                <div class="title">{{ comment.message }}</div>
                <div class="time">{{ comment.created_at | moment("DD/MM/YYYY") }}</div>
            </div>
        </div>
        <div class="small-8 medium-4 column">
            <router-link v-if="this.comment.material" :to="{ name: 'material', params: { id: comment.material.id } }" class="file-link">
                <svg class="file-icon icon" :class="'icon-' + basicType"><use :xlink:href="'#' + basicType"></use></svg>
                <span>{{ this.comment.material.title }}</span>
            </router-link>
        </div>
        <div class="small-4 medium-2 column form-horizontal">
            <button v-if="!seen" type="button" @click="setAsSeen()" class="button secondary clear inline-button" title="Atzīmēt kā redzētu"><svg-icon :symbol="eyeIcon.default"></svg-icon> Redzēts</button>
        </div>
    </div>
</template>

<script>
    import materials from '../../api/materials'
    import Avatar from '../../components/Avatar'
    import user from '../../api/user'
    import SvgIcon from '../../components/SvgIcon'
    import { mapGetters } from 'vuex'

    export default {
        name: 'comment',

        props: {
            comment: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                eyeIcon: require('../../../icons/icon-eye.svg-sprite')
            }
        },

        components: {
            Avatar, SvgIcon
        },

        methods: {
            setAsSeen() {
                user.seenComment(this.comment.id)
                    .then(response => {
                        this.$store.dispatch('getInboxStats')

                        //TODO dispatch event and reload from parent
                        //we fake seen status disregarding current user role in this comment
                        this.comment.seen_by_recipient = true
                        this.comment.seen_by_sender = true
                })
            }
        },

        computed: {

            ...mapGetters(['user']),

            basicType: function () {
                return materials.basicType(this.comment.material)
            },

            seen: function() {
                if (this.user && this.comment) {
                    if (this.user.id === this.comment.user_id) {
                        return this.comment.seen_by_sender
                    } else if (this.user.id === this.comment.material.owner_id) {
                        return this.comment.seen_by_recipient
                    }
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .comments-list-item {
        &.unseen {
            background-color: lighten($body-background, 2.5%);
        }
    }

    .file-link {
        display: flex;
        align-items: center;

        .file-icon {
            margin-right: 1em;
            width: 50px;
            height: 50px;
            flex: 0 0 auto;
        }
    }

    .comment-details {
        margin-left: calc(50px + 1em);
    }

    .avatar-link {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        left: 15px;
    }

    .author-link {
        color: $body-color;
        font-weight: 700;
    }

    .time {
        color: #a6b4c0;
        font-size: 12px / 16px + em;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/inbox/Comment.vue